import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const ReportsContent = lazy(() => import('../../components/Pages/Reports'));

export default function Reports(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Reports page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <ReportsContent />
      </Suspense>
    </Layout>
  );
}
